<template>
  <BModal
    id="doctor-document-preview-modal"
    size="lg"
    centered
    hide-footer
    :title="previewTitle"
  >
    <div class="ddp-body">
      <p v-if="previewMode === 'loading'" class="ddp-loading">Carregando...</p>

      <img
        v-else-if="previewMode === 'image'"
        :src="previewUrl"
        :alt="previewTitle"
        class="ddp-image"
        @error="previewMode = 'pdf'"
      />

      <iframe
        v-else-if="previewMode === 'pdf'"
        :src="previewUrl"
        class="ddp-iframe"
        :title="previewTitle"
      />

      <p v-else class="ddp-error">Não foi possível carregar o documento.</p>
    </div>
  </BModal>
</template>

<script>
import { doctorDocumentMethods } from "../state/helpers";

export default {
  name: "DoctorDocumentPreviewModal",
  data() {
    return {
      previewUrl: "",
      previewTitle: "Documento",
      previewMode: null
    };
  },
  methods: {
    ...doctorDocumentMethods,

    async open(docId, side, title) {
      this.previewTitle = title;
      this.previewUrl = "";
      this.previewMode = "loading";
      this.$bvModal.show("doctor-document-preview-modal");

      try {
        const response = await this.showDocument(docId);
        this.previewUrl = response.data[side];
        this.previewMode = this.previewUrl ? "image" : null;
      } catch (error) {
        this.previewMode = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ddp-body {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: var(--space-4);
}

.ddp-loading,
.ddp-error {
  color: var(--color-gray-500);
  font-size: var(--font-size-sm);
}

.ddp-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.ddp-iframe {
  width: 100%;
  height: 70vh;
  border: 0;
}
</style>
